export const ROOT = '/user';
export const MODULE = 'USER';
